import { message } from "antd";
import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockSendCreatorApplyVerificationCode,
  mockSubmitCreatorApply,
} from "./CreatorApplyMock";
import type { CreatorApplyPayload, CreatorApplyResult } from "./CreatorApplyType";

const mock = useLongfansMock && false;

const sendApplyVerificationCode = async (
  phoneNo: string,
  captchaToken?: string,
): Promise<boolean> => {
  if (mock) {
    return mockSendCreatorApplyVerificationCode(phoneNo);
  }
  const res = await post<
    { phoneNo: string; captchaToken?: string },
    boolean
  >(
    "/lark/app/creator/sendApplyVerificationCode",
    {
      phoneNo,
      ...(captchaToken ? { captchaToken } : {}),
    },
    { silent: true },
  );
  if (typeof res === "string") {
    if (res === "1006") {
      message.error("发送过于频繁，请稍后再试");
    } else if (res === "1009") {
      message.error("请先完成滑动验证");
    } else if (res === "1010") {
      message.error("滑动验证已失效，请重试");
    }
    return false;
  }
  return !!res;
};

const submitApply = async (
  payload: CreatorApplyPayload
): Promise<CreatorApplyResult | null> => {
  if (mock) {
    return mockSubmitCreatorApply(payload);
  }
  const res = await post<CreatorApplyPayload, CreatorApplyResult>(
    "/lark/app/creator/submitApply",
    payload
  );
  if (typeof res === "string" || !res?.success) {
    return null;
  }
  return res;
};

export const CreatorApplyApi = {
  sendApplyVerificationCode,
  submitApply,
};
